import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useStep} from "../hooks/useStep.ts";
import {Step} from "../types.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: playbookId, phaseId, stepId} = useParams();

    if (typeof stepId === 'undefined') {
        throw new Error('stepId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useStep(stepId);

    if (!record) return null;

    // Keep parent scope (phaseId / playbookId) pinned from the route in case
    // the backend payload returned partial data or the user edits the record
    // in a context where these are authoritative.
    const seededRecord = {
        ...record,
        ...(playbookId ? {playbookId} : {}),
        ...(phaseId ? {phaseId} : {}),
    } as Step;

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
